// ============================================================================
// TotpEnrollFlow
// Owner: Claude 3 (Frontend & UX).
// Purpose: TOTP enroll — fetch secret, render QR, verify 6-digit code.
// URS rows: AUTH-002.
// ============================================================================
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEnrollTotp, useVerifyTotp } from '../../api/twoFactorHooks';

export function TotpEnrollFlow({ onDone }: { onDone: () => void }) {
  const { t } = useTranslation();
  const enroll = useEnrollTotp();
  const verify = useVerifyTotp();
  const [code, setCode] = useState('');

  useEffect(() => {
    if (!enroll.data && !enroll.isPending) enroll.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (enroll.isPending) return <p>{t('twofa.totp.qr_instruction')}…</p>;
  if (enroll.isError) return <p role="alert">{String(enroll.error)}</p>;
  if (!enroll.data) return null;

  return (
    <div>
      <h2>{t('twofa.totp.card_title')}</h2>
      <p>{t('twofa.totp.qr_instruction')}</p>
      {enroll.data.qrPngBase64 ? (
        <img
          src={`data:image/png;base64,${enroll.data.qrPngBase64}`}
          alt={t('twofa.totp.qr_instruction')}
        />
      ) : (
        <code>{enroll.data.provisioningUri}</code>
      )}
      <p>
        <label htmlFor="totp-secret">{t('twofa.totp.manual_entry_label')}</label>
        <code id="totp-secret" style={{ marginInlineStart: 8 }}>
          {enroll.data.secret}
        </code>
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          verify.mutate({ code }, { onSuccess: () => onDone() });
        }}
      >
        <label htmlFor="totp-code">{t('twofa.totp.verify_prompt')}</label>
        <input
          id="totp-code"
          inputMode="numeric"
          pattern="\d{6}"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        <button type="submit" disabled={verify.isPending}>
          {t('twofa.common.set_up')}
        </button>
      </form>
      {verify.isError && <p role="alert">{String(verify.error)}</p>}
    </div>
  );
}
